import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd } from '@angular/router';
import { UserService } from '../../services/user.service';
import { UpaegService } from '../../services/upaeg.service';
import { SolicitudesService } from '../../services/solicitudes.service';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ConfirmPopComponent} from '../confirm-pop/confirm-pop.component';
import {AlertPopComponent} from '../alert-pop/alert-pop.component';

import {environment} from '../../../environments/environment';
declare let gtag: (property: string, value: any, configs: any) => {};

@Component({
  selector: 'app-presolicitudes',
  templateUrl: './presolicitudes.component.html',
  styleUrls: ['./presolicitudes.component.css'],
  providers: [UserService, UpaegService, SolicitudesService]
})
export class PresolicitudesComponent implements OnInit {
  public upaeg: any;
  public constancias: any;
  public presolicitudes: any;
  public idProductor;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private upaegService : UpaegService,
    private solicitudesService: SolicitudesService,
    public dialog: MatDialog
  ) {
    this.upaeg = null;
    this.constancias = null;
    this.presolicitudes = null;

    this.router.events.subscribe(event => {
      if(event instanceof NavigationEnd){
        gtag('config', environment.googleAnalyticsId, {
          page_path: event.urlAfterRedirects
        });
      }
    });
   }

  ngOnInit() {
    /* VALIDATE SESSION */
    if (this.userService.getToken()){
      this.userService.check_session().subscribe(response => {
        if (response.status) {
        } else {
          this.userService.destroy_session();
          this.router.navigate(['/login']);
        }
      }, error => {
        console.log(error);
        this.userService.destroy_session();
        this.router.navigate(['/login']);
      });
    }else{
      this.userService.destroy_session();
      this.router.navigate(['/login']);
    }
   /* VALIDATE SESSION */
   this.getParams();

  }

  alertDialog(title, text, action): void {
    const dialogRef = this.dialog.open(AlertPopComponent, {
      width: '40%',
      data: {
        titulo: title,
        texto: text,
        confirm: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

  getDetalles(idUpaeg){
    this.solicitudesService.getDetalleUpaeg(idUpaeg).subscribe(response => {
      console.log(response);
      if(response.status){
        this.upaeg = response.upaegInfo;
      }else{
        this.alertDialog('Error', response.message, 'Cerrar');
      }
    }, error => {
        console.log(error);
        this.alertDialog('Error', 'No se puede procesar su petición en este momento', 'Cerrar');
    });
  }

  getPresolicitudesUpaeg(idProductor){
    this.solicitudesService.getPresolicitudesUpaeg(idProductor).subscribe(response => {
      console.log(response);
      if(response.status){
        if(response.solicitudes){
          this.presolicitudes = response.solicitudes;
        }else{
          this.presolicitudes = false;
        }
      }else{
        this.alertDialog('Atención', response.message, 'Cerrar');
      }

    }, error => {
      console.log(error);
      this.alertDialog('Error', 'No se pueden cargar los expedientes de la unidad de producción, error interno', 'Cerrar');
    });
  }



  /*
getPresolicitudesUpaeg(idProductor): Observable<any> {
    let headers = new HttpHeaders().set('Content-Type', 'application/json').set('Authorization', this.getToken());
    return this._http.get(this.url + 'presol/get/presolicitudes/'+idProductor, { headers });
  }
  */



  getParams() {
    this.route.params.subscribe(params => {
      if (params.id){
        this.idProductor = params.id;
        this.getDetalles(params.id);
        this.getPresolicitudesUpaeg(params.id);
      }else{
        this.router.navigate(['/misupaegs']);
      }
    });

  }

}
